import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getServices } from '../../services/services';
import { onQuerySuccess } from '../../utils/queryResponse';
import FormSelect from '../forms/formSelect';

const ServiceSelect = ({ value, isMulti, serviceId, ...rest }) => {

    const [options, setOptions] = useState([])

    const { data, isLoading } = useQuery(['services'], () => getServices())

    useEffect(() => {
        onQuerySuccess(data, (result) => {
            if (result.length > 0) {
                const enabled = result.filter(x => !x.disabled)
                // A line keeps its service after that service is disabled: add it
                // back so the select can still show it — but only then, or it
                // would be listed twice.
                const current = serviceId ? result.find(x => x.id === serviceId) : null
                const _options = current && current.disabled ? [...enabled, current] : enabled
                setOptions(_options.map(d => ({
                    value: d.id, label: d.name, ppu: d.pricePerUnit, unit: d.unit
                })))
            }
        })
    }, [data, serviceId])

    return (
        <FormSelect isMulti={isMulti} {...rest}
            value={
                isMulti ? (value && value.map(val => ({ value: val, label: val }))) :
                    (options.find(opt => opt.value === value) || null)
            }
            options={options}
            isLoading={isLoading}
        />
    )
}

export default ServiceSelect